export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
}

export const fontFamily = {
  primary: 'degular, sans-serif',
  primaryDisplay: 'degular-display, sans-serif',
  primaryText: 'degular-text, sans-serif',
  secondary: `'Shrikhand', cursive`,
  tertiary: 'degular, sans-serif',
}

const new_typography = {
  display_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  display_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  display_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  headline_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  headline_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  headline_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  title_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  title_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  title_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  label_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  label_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  label_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  body_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  body_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  body_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  data_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  data_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  data_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  legal_l: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  legal_m: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
  legal_s: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: '',
    fontFamily: '',
    letterSpacing: 0,
    fontKerning: '',
  },
}

const typography = {
  heroSecondary: {
    fontSize: 72,
    lineHeight: '72px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
    letterSpacing: -1,
    fontKerning: 'none',
  },
  valueLargeSecondary: {
    fontSize: 62,
    lineHeight: '62px',
    letterSpacing: -1,
    fontFamily: fontFamily.secondary,
    fontKerning: 'none',
  },
  valueLargeDisplay: {
    fontSize: 72,
    fontStyle: 'italic',
    fontWeight: fontWeight.bold,
    lineHeight: '56px',
    fontFamily: fontFamily.primaryDisplay,
  },
  heroDisplay: {
    fontSize: 56,
    lineHeight: 1,
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
  },
  subtitleLargeSecondary: {
    fontSize: 48,
    lineHeight: '48px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
    letterSpacing: -0.5,
    fontKerning: 'none',
  },

  heroXLargeSecondary: {
    fontSize: 60,
    lineHeight: '60px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
    // bp: {
    //   md: {
    //     fontSize: 100,
    //     lineHeight: '100px',
    //   },
    // },
  },
  valueXLarge: {
    fontSize: 96,
    lineHeight: '75px',
    letterSpacing: -2,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  valueLargeLight: {
    fontSize: 48,
    lineHeight: '48px',
    letterSpacing: -1,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  valueLarge: {
    fontSize: 48,
    lineHeight: '48px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  valueLargeMedium: {
    fontSize: 48,
    lineHeight: '48px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  valueLargeBold: {
    fontSize: 48,
    lineHeight: '48px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
  },
  labelLargeBold: {
    fontSize: 42,
    lineHeight: '42px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
  },
  stat: {
    fontSize: 32,
    lineHeight: 1,
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
    // bp: {
    //   lg: {
    //     fontSize: 48,
    //   },
    // },
  },
  h1Secondary: {
    fontSize: 40,
    lineHeight: '48px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
  },
  h2: {
    fontSize: 36,
    lineHeight: 1,
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
  },
  nameplateLightTall: {
    fontSize: 32,
    lineHeight: '42px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  nameplate: {
    fontSize: 32,
    lineHeight: '34px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  nameplateBold: {
    fontSize: 32,
    lineHeight: 1,
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
  },
  nameplateSecondary: {
    fontSize: 32,
    lineHeight: '32px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
    fontKerning: 'none',
  },
  h2Secondary: {
    fontSize: 32,
    lineHeight: '40px',
    fontWeight: fontWeight.regular,
    letterSpacing: 0.16,
    fontFamily: fontFamily.secondary,
  },
  valueSmallLight: {
    fontSize: 28,
    lineHeight: '38px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  valueSmall: {
    fontSize: 28,
    lineHeight: '28px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  valueSmallBold: {
    fontSize: 28,
    lineHeight: '28px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  valueSmallTertiary: {
    fontSize: 28,
    lineHeight: '28px',
    fontWeight: fontWeight.regular,
    letterSpacing: -1,
    fontFamily: fontFamily.tertiary,
  },
  nameplateSmallRegular: {
    fontSize: 26,
    lineHeight: '30px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  nameplateSmallMedium: {
    fontSize: 26,
    lineHeight: '30px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  flashyLabel: {
    fontSize: 24,
    lineHeight: '24px',
    fontFamily: fontFamily.secondary,
    fontWeight: fontWeight.regular,
  },
  dataLargeLight: {
    fontSize: 24,
    lineHeight: 1,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  dataLarge: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  dataLargeMedium: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  dataLargeBold: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  h3Secondary: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.secondary,
  },
  title: {
    fontSize: 22,
    lineHeight: '28px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  subtitleLarge: {
    fontSize: 21,
    lineHeight: '23px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  sectionLabel: {
    fontSize: 21,
    lineHeight: '23px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  sectionLabelBold: {
    fontSize: 21,
    lineHeight: '23px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  sectionBody: {
    fontSize: 20,
    lineHeight: '30px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  labelUpperTertiary: {
    fontSize: 18,
    lineHeight: '18px',
    fontWeight: fontWeight.medium,
    letterSpacing: 1,
    fontFamily: fontFamily.tertiary,
    textTransform: 'uppercase',
  },
  bodyLight: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  body: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  bodyTall: {
    fontSize: 18,
    lineHeight: '27px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  link: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
    cursor: 'pointer',
  },
  bodyLabelMedium: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  bodyLabelSemibold: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  bodyBoldSpaced: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.semibold,
    letterSpacing: 0.2,
    fontFamily: fontFamily.primary,
  },
  bodyLabelBold: {
    fontSize: 18,
    lineHeight: '21px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  bodyBolderTertiary: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.tertiary,
  },
  bodyBolderSpacedMore: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.bold,
    letterSpacing: 2,
    fontFamily: fontFamily.primary,
  },
  labelSecondary: {
    fontSize: 24,
    lineHeight: '18px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primaryDisplay,
    fontStyle: 'italic',
  },
  locationLabelLarge: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: 10,
    fontFamily: fontFamily.primary,
  },
  locationLabelLargeSomeSpace: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: 5,
    fontFamily: fontFamily.primary,
  },
  p: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeight.medium,
    letterSpacing: 0.08,
    fontFamily: fontFamily.primary,
  },
  pMediumSpaced: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeight.semibold,
    letterSpacing: 0.08,
    fontFamily: fontFamily.primary,
  },
  pTall: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  data: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  dataTertiary: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.tertiary,
  },
  chipLabel: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  buttonAlt: {
    fontSize: 16,
    lineHeight: 1,
    fontFamily: fontFamily.primary,
  },
  buttonLarge: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: fontWeight.semibold,
    textTransform: 'none',
    letterSpacing: 0.08,
    fontFamily: fontFamily.primary,
  },
  bodyMediumSpaced: {
    fontSize: 16,
    lineHeight: '22px',
    letterSpacing: 0.08,
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  dataBoldTertiaryUpper: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.tertiary,
  },
  bodyMediumBoldSpaced: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeight.bold,
    letterSpacing: 0.08,
    fontFamily: fontFamily.primary,
  },
  bodyBold: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  bodyBoldUpper: {
    fontSize: 16,
    lineHeight: '24px',
    textTransform: 'uppercase',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
    letterSpacing: 3,
  },
  dataBoldTertiaryUpperSpaced: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.tertiary,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
  dataLabel: {
    fontSize: 15,
    lineHeight: '21px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  dataLabelMedium: {
    fontSize: 15,
    lineHeight: '21px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  dataSmall: {
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  bodySmall: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  bodySmallSpaced: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
    letterSpacing: 0.1,
  },
  dataSmallTertiary: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.tertiary,
  },
  labelSmall: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  button: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: fontWeight.semibold,
    textTransform: 'none',
    fontFamily: fontFamily.primary,
  },

  headerSmall: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  locationLabel: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.semibold,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: fontFamily.primary,
  },
  dataSmallLabelTertiary: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.tertiary,
  },
  bodySmallBold: {
    fontSize: 14,
    lineHeight: '21px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  labelSmallTertiaryUpper: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: fontWeight.medium,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontFamily: fontFamily.tertiary,
  },
  labelSmallTertiaryUpperBold: {
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontFamily: fontFamily.tertiary,
  },
  locationLabelSpaced: {
    fontSize: 14,
    lineHeight: 1,
    fontWeight: fontWeight.semibold,
    textTransform: 'uppercase',
    letterSpacing: 3,
    fontFamily: fontFamily.primary,
  },
  subLabel: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  subLabelSemibold: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  subLabelMedium: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  dataMicro: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  dataMicroTertiary: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.tertiary,
  },
  dataMicroMediumTertiary: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.tertiary,
  },
  dataMicroMediumTertiaryUpper: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.tertiary,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  labelMicroMedium: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  labelMicroMediumUpper: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.semibold,
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontFamily: fontFamily.primary,
  },
  labelMicroBoldUpper: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontFamily: fontFamily.primary,
  },
  labelMicroBoldTertiaryUpper: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.bold,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: fontFamily.tertiary,
  },
  dataMicroBold: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  finePrint: {
    fontSize: 11,
    lineHeight: '18px',
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.primary,
  },
  labelAtomic: {
    fontSize: 11,
    lineHeight: '12px',
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.primary,
  },
  labelAtomicMedium: {
    fontSize: 11,
    lineHeight: '16px',
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  labelAtomicMediumUpperTertiary: {
    fontSize: 11,
    lineHeight: '16px',
    fontWeight: fontWeight.medium,
    textTransform: 'uppercase',
    letterSpacing: 0.83,
    fontFamily: fontFamily.tertiary,
  },
  labelAtomicBold: {
    fontSize: 11,
    lineHeight: '12px',
    fontWeight: fontWeight.bold,
    fontFamily: fontFamily.primary,
  },
  labelAtomicBoldSpaced: {
    fontSize: 11,
    lineHeight: '24px',
    fontWeight: fontWeight.bold,
    letterSpacing: 0.56,
    textTransform: 'uppercase',
    fontFamily: fontFamily.primary,
  },
  labelSubAtomicMedium: {
    fontSize: 10,
    lineHeight: 1,
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.primary,
  },
  dataSubAtomic: {
    fontSize: 10,
    lineHeight: '14px',
    fontFamily: fontFamily.primary,
  },
  labelSubAtomicMediumUpper: {
    fontSize: 10,
    lineHeight: 1,
    letterSpacing: 1,
    fontWeight: fontWeight.semibold,
    textTransform: 'uppercase',
    fontFamily: fontFamily.primary,
  },
  labelSubatomicTertiary: {
    fontSize: 10,
    lineHeight: 1,
    fontWeight: fontWeight.medium,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: fontFamily.tertiary,
  },
  labelSubatomicBoldTertiary: {
    fontSize: 10,
    lineHeight: 1,
    fontWeight: fontWeight.bold,
    letterSpacing: 1,
    textTransform: 'uppercase',
    fontFamily: fontFamily.tertiary,
  },
  inherit: {},
}

export default typography
